import axios from 'axios'

console.log('URL', process.env.VUE_APP_SYMBO_API_URL)

// initial state
const state = () => ({
  user: null,
  selectedMailboxId: null,
});

// getters
const getters = {
  user: (state) => state.user,
  mailboxes: (state, getters) => getters.user?.mailboxes || [],
  mailbox: (state, getters) => {
    if (state.selectedMailboxId) {
      const selected = getters.mailboxes.find(
        (m) => m.id === state.selectedMailboxId
      )
      if (selected) return selected
    }
    return (
      getters.mailboxes.find((m) => m.is_primary) || getters.mailboxes[0]
    )
  },
};

// mutations
const mutations = {
  setUser(state, newVal) {
    state.user = newVal;
  },
  setSelectedMailboxId(state, newVal) {
    state.selectedMailboxId = newVal;
  },
};

// actions
const actions = {
  async fetchUser({ commit }) {
    const axiosWithToken = axios.create({
      baseURL: process.env.VUE_APP_SYMBO_API_URL,
      headers: {
        "X-Stytch-JWT": localStorage.getItem("token"),
      },
    })
    try {

      const response = await axiosWithToken.get('/userProfile')

      if (response?.data) commit("setUser", response.data);

      // Remove token from URL
    } catch (error) {
      console.error(error);
    }
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
